<template>
    <ul class="divide-y divide-dashed divide-gray-200">
        <slot />
    </ul>
</template>
